export default {
  en: {
    locale: 'en-GB',
    messages:
      {
      appName: 'London Bike Maps',
      loading: 'Loading please wait...',
      bikes: 'Bikes',
      spaces: 'Spaces',
      settings: 'Options',
      bikesFree: 'bikes',
      spacesFree: 'spaces',
      terminalName: 'terminal',
      totalSpaces: 'total',
      search: 'Search name or terminal no..',
      nearbyStations: 'Nearest stations',
      distance: 'distance',
      thisProjectUses: 'This project uses the',
      projectApiDescription: 'TfL Unified API',
      thisProjectReason: 'to provide live cycle hire station data',
      writtenBy: 'It was written by',
      technology: 'using React/Redux'
     }
  },
  se: {
    locale: 'se',
    messages:
      {
          appName: 'London cykel karta',
          loading: 'vänta...',
          bikes: 'cyklar',
          spaces: 'lediga platser',
          settings: 'inställningar',
          bikesFree: 'cyklar',
          spacesFree: 'cykel parker',
          terminalName: 'terminal',
          totalSpaces: 'totala ställen',
          search: 'sök namn eller terminal nummer..',
          nearbyStations: 'Närmaste terminaler',
          distance: 'distans',
          thisProjectUses: 'Detta projekt använder',
          projectApiDescription: 'TfL Unified API',
          thisProjectReason: 'för att tillhandahålla cykelstationsdata',
          writtenBy: 'Det ar av',
          technology: 'med React/Redux'
    }
  }
}


// WEBPACK FOOTER //
// ./src/translations.js